angular.module('jv.video.recruiter.details.controller',[])
    .controller('VideoDetailsCtrl',['$scope', 'videoService',  '$timeout', '$window', '$jobviteUrls', '$routeParams','jvHireUrlService',
        function($scope, videoService, $timeout, $window, $jobviteUrls, $routeParams,jvHireUrlService){
            $scope.result = null;
            $scope.parent = { };
            $scope.parent.shouldAutoPlay = false;
            $scope.saving=false;
            $scope.parent.selectedVideoId = null;
            $scope.parent.selectedVideoUrls = null;
            $scope.parent.selectedIndex = 0;
            var interviewId = $routeParams.interviewId;
            var appId = $routeParams.applicationId;
            videoService.isVonageEnabled({
                'formResponseId': interviewId
            }, function (result) {
                if (angular.isDefined(result)) {
                    $scope.vonageRecording = result.isVonage;
                    $scope.showPlayVideo = false;
                }
            });
            $scope.applicationId  = appId;
            // Object for saving or saving as draft.
            $scope.saveDraftObject = { };

            //check if the answers exist or not for a given interview.
            var ifAnswersExist = function( result ){
                return angular.isDefined(result.bean) && result.bean !== null && angular.isDefined(result.bean.answers) && result.bean.answers !== null && result.bean.answers.length;
            };

            $scope.showPlayVideoToggle = function(value) {
                $scope.showPlayVideo = value;
            };

            //check if the comments exist for the given interview
            var ifCommentsExist = function(result){
                return angular.isDefined(result) && angular.isDefined(result.evaluation) && result.evaluation !== null && angular.isDefined(result.evaluation.evaluations) && result.evaluation.evaluations !== null &&  result.evaluation.evaluations.length;
            };

            var ifSubmittedEvaluation = function(result){
                return angular.isDefined(result) && angular.isDefined(result.users) && result.users !== null && result.users.length>0;
            };

            //Add the "questionsHash" and "commentHash" which is not present in the array.
            var massageResult = function(result){
                // comments hash based on the question id. Gives you the comment for the question and the rating.
                result.bean.commentsHash = { };
                if(ifCommentsExist(result)){
                    angular.forEach(result.evaluation.evaluations, function(value){
                        result.bean.commentsHash[value.question.SId] = value;
                    });
                }else{
                    result.evaluation=result.evaluation||{ };
                }
                // hash based on the question id. Gives you the sequence, title for the question.
                result.bean.questionsHash = { };
                if (ifAnswersExist(result)) {
                    angular.forEach(result.bean.answers, function(value){
                        result.bean.questionsHash[value.videoId] = value;
                        if(typeof result.bean.commentsHash[value.question.SId]==='undefined'){
                            //There might be no comments or ratings for a specific questionID
                            result.bean.commentsHash[value.question.SId]={ };
                        }
                    });
                }

                function sanitize(text){
                    if(angular.isUndefined(text) || text === null || typeof text !== 'string'){
                        return text;
                    }
                    return $('<div></div>').text(text).html().replace(/\n/g, '<br/>');
                }
                //Hash for the users.
                result.userHash ={ };
                //Hash for completed evaluations
                result.completedEvaluationsHash = { };
                if(ifSubmittedEvaluation(result)){
                    angular.forEach(result.users, function(value){
                        result.userHash[value.EId]= value;
                    });
                    angular.forEach(result.completedEvaluations, function(value){
                        result.completedEvaluationsHash[value.question.SId] = value.evaluations;
                        var evaluation = result.completedEvaluationsHash[value.question.SId];
                        angular.forEach(evaluation, function(entity,token){
                            (evaluation[token]).comment = sanitize(evaluation[token].comment);
                        });
                    });
                }
                return result;
            };

            var timerPromise=null;
            $scope.showOnUnloadMessage = false;

            $scope.submitRating = function(type, action){
                if(type ==='eval'){
                    var evalRating = $scope.result.bean.commentsHash[$scope.result.bean.questionsHash[$scope.parent.selectedVideoId].question.SId].rating;
                    if(evalRating === action){
                        evalRating=-1;
                    }else{
                        evalRating=action;
                    }
                    $scope.result.bean.commentsHash[$scope.result.bean.questionsHash[$scope.parent.selectedVideoId].question.SId].rating=evalRating;
                }else{
                    //overalleval
                    var overallRating = $scope.result.evaluation.rating;
                    if(overallRating === action){
                        overallRating=-1;
                    }else{
                        overallRating=action;
                    }
                    $scope.result.evaluation.rating=overallRating;
                    $scope.overallEvaluationForm.evaluated = true;
                }
                $scope.submitEvaluations();
            };

            $scope.submitEvaluations =  function(ifSubmit, ifRedirect, saveShow){
                if(!!$scope.result.evaluation.comment || !!$scope.overallEvaluationForm.evaluated) {
                    $scope.overallEvaluationForm.showError = false;
                }else if(ifSubmit){
                    $scope.overallEvaluationForm.showError = true;
                    return;
                }
                $scope.showOnUnloadMessage = true;
                $scope['savingdraft'] = false;
                $scope['savingsubmit'] = false;
                $scope['saving'+saveShow] = true;
                $timeout.cancel(timerPromise);
                timerPromise = $timeout(function(){
                    var submitObj = { };
                    submitObj.comment = $scope.result.bean.commentsHash[$scope.result.bean.questionsHash[$scope.parent.selectedVideoId].question.SId].comment;
                    submitObj.overallComment = $scope.result.evaluation.comment;
                    submitObj.rating = $scope.result.bean.commentsHash[$scope.result.bean.questionsHash[$scope.parent.selectedVideoId].question.SId].rating;
                    submitObj.overallRating = $scope.result.evaluation.rating;
                    if(angular.isDefined(ifSubmit) && ifSubmit === true){
                        submitObj.submit = true;
                    }else{
                        submitObj.submit = false;
                    }
                    submitObj.vid = $scope.parent.selectedVideoId;
                    submitObj.appId = appId;
                    videoService.submitEvaluations(submitObj,function(){
                        $scope['saving'+saveShow] = false;
                        if(ifRedirect){
                            $scope.showOnUnloadMessage = false;
                            $window.location.href = jvHireUrlService.getApplicationDetailsUrl(appId,false,'videos');
                        }
                    });
                }, 380);
            };

            $scope.navigateVideo = function(ifForward){
                var _parent = $scope.parent;
                var _answers = $scope.result.bean.answers;
                if (ifForward && _parent.selectedIndex === _answers.length - 1 || (!ifForward && _parent.selectedIndex === 0)  ) {
                    return;
                }else if(ifForward && _parent.selectedIndex < _answers.length-1){
                    _parent.selectedIndex=_parent.selectedIndex+1;
                }else{
                    _parent.selectedIndex=_parent.selectedIndex-1;
                }
                _parent.selectedVideoId = (_answers[_parent.selectedIndex]).videoId;
                _parent.selectedVideoUrls = (_answers[_parent.selectedIndex]).videoUrls;
                $scope.parent.shouldAutoPlay = true;
            };

            videoService.getInterviewDetails({
                'id': interviewId,
                'appId':appId
            }, function(result){
                $scope.result = massageResult(result);
                if (ifAnswersExist(result)) {
                    $scope.parent.selectedVideoId = result.bean.answers[0].videoId;
                    $scope.parent.selectedVideoUrls = result.bean.answers[0].videoUrls;
                }
                $scope.flags.loading = false;
            });
        }
]);
